import { useQuery } from '@tanstack/react-query'

import { getScimAccessToken } from '@src/api'
import { DefaultApiGetScimAccessTokenRequest } from '@src/api/generated/iam'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchScimAccessToken = (
  params: DefaultApiGetScimAccessTokenRequest
) => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getScimAccessToken(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_SCIM_ACCESS_TOKEN,
      params.organizationId,
    ],
  })
}
